import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("lexv_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  // Demo visitors: the guest pass lets the server allow speech scoring on free samples
  else if (!cfg.headers.Authorization) {
    try { const g = JSON.parse(localStorage.getItem("lexv_guest"))?.token; if (g) cfg.headers.Authorization = `Bearer ${g}`; } catch { /* no guest */ }
  }
  return cfg;
});
// Another device signed in: tell the app once, it clears the session and shows a notice
api.interceptors.response.use((r) => r, (e) => {
  if (e?.response?.status === 401 && e.response.data?.detail?.code === "SESSION_TERMINATED_CONCURRENT_LOGIN") {
    window.dispatchEvent(new Event("lexv-session-ended"));
  }
  return Promise.reject(e);
});

export const errMsg = (e) => {
  const data = e?.response?.data;
  if (e?.response && (typeof data !== "object" || data === null)) return "Something went wrong on our side. Please try again in a moment.";
  const d = data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => _stripValue(x)).join(" ");
  return d.message || (d.msg || String(d)).replace(/^Value error, /, "");
};
const _stripValue = (x) => (x?.msg || JSON.stringify(x)).replace(/^Value error, /, "");
